/**
 * @file 公共方法
 * @author (zhanghao14)
 */

/* global document window getComputedStyle Promise window*/

import '../assets/less/Base.less';
import '../assets/less/Common.less';

import promise from 'bluebird';
if (!window.Promise) {
    // 兼容ie11
    window.Promise = promise;
}

/**
 * 一个空函数
 */
export var noop = function noop() {};

export var contains = function contains(root, n) {
    var node = n;
    while (node) {
        if (node === root) {
            return true;
        }
        node = node.parentNode;
    }

    return false;
};

/**
 * 异步判断节点是否包含
 *
 * @param {node} root  根节点
 * @param {node} n  子节点
 * @return {Promise} Promise对象
 */
export var containsAsync = function containsAsync(root, n) {
    return new Promise(function (resolve, reject) {
        var node = n;
        var result = false;
        try {
            setTimeout(function () {
                while (node) {
                    if (node === root) {
                        result = true;
                    }
                    node = node.parentNode;
                }
                resolve(result);
            }, 0);
        } catch (error) {
            reject(error);
        }
    });
};

/**
 * @const
 */
var SPUI_INIT = 1;
var SPUI_INIT_RESULT = SPUI_INIT;
/**
 * @const
 */
var SPUI_INPUT_LOOP = 'spuiElement';
export var inputLoop = function inputLoop() {
    return SPUI_INPUT_LOOP + '' + SPUI_INIT_RESULT++;
};

/**
 * 获取dom节点的位置
 *
 * @interface getDOMPosition
 * @param {HtmlElement} e dom节点
 * @return {PositionState} 位置对象
 */
export var getDOMPosition = function getDOMPosition(e) {
    var getCompatElement = function getCompatElement(elem) {
        var doc = elem && elem.ownerDocument || document;
        var compatMode = doc.compatMode;
        return !compatMode || compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
    };
    var getPositionInViewport = function getPositionInViewport(elem) {
        var bounding = elem.getBoundingClientRect();
        var clientTop = getCompatElement().clientTop;
        var clientLeft = getCompatElement().clientLeft;
        return {
            top: bounding.top - clientTop,
            left: bounding.left - clientLeft
        };
    };
    var getPositionInDocument = function getPositionInDocument(elem) {
        var scrollTop = 'pageYOffset' in window ? window.pageYOffset : getCompatElement().scrollTop;
        var scrollLeft = 'pageXOffset' in window ? window.pageXOffset : getCompatElement().scrollLeft;
        var positionInViewport = getPositionInViewport(elem);
        return {
            top: positionInViewport.top + scrollTop,
            left: positionInViewport.left + scrollLeft
        };
    };
    var getDOMSize = function getDOMSize(elem) {
        var _getComputedStyle = getComputedStyle(elem),
            width = _getComputedStyle.width,
            height = _getComputedStyle.height;

        return {
            width: parseInt(width, 10),
            height: parseInt(height, 10)
        };
    };
    var positionInViewport = getPositionInViewport(e);
    var positionInDocument = getPositionInDocument(e);
    var size = getDOMSize(e);
    return {
        x: positionInViewport.left,
        y: positionInViewport.top,
        left: positionInDocument.left,
        top: positionInDocument.top,
        width: size.width,
        height: size.height
    };
};

/**
 * form验证规则
 * author (zhaojun10)
 */

export var rule = {
    isRequired: function isRequired(value) {
        var v = value.replace(/(^\s*)|(\s*$)/g, '');
        return v.length;
    },
    count: function count(value) {
        var v = value.replace(/(^\s*)|(\s*$)/g, '');
        return v.length > 16 && v.length < 1;
    }
};

/**
 * 阻止鼠标滚动，滚动条还在
 * 阻止鼠标滚动，滚动条消失
 * author (zhaojun10)
 */

var scrollWheelFlag = function scrollWheelFlag() {
    var scrollWheel = {
        oldonmousewheel1: window.onmousewheel,
        oldonmousewheel2: document.onmousewheel,
        oldontouchmove: window.ontouchmove,
        oldonkeydown: document.onkeydown,
        oldonwheel: window.onwheel,
        isDisabled: false
    };

    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.returnValue = false;
    }

    function preventDefaultForScrollKeys(e) {
        e = e || window.event;
        if (37 <= e.keyCode && e.keyCode <= 40) {
            return function (e) {
                e.stopPropagation;
                if (e.preventDefault) {
                    e.preventDefault();
                }
                e.returnValue = false;
                return false;
            };
        }
    }

    return {
        scrollPrevent: function scrollPrevent() {
            document.documentElement.style.overflow = 'hidden';
            // document.body.style.overflow = 'hidden';
            document.body.onkeydown = function (e) {
                if (37 <= e.keyCode && e.keyCode <= 40) {
                    return function (e) {
                        e.preventDefault && e.preventDefault();
                        e.returnValue = false;
                        e.stopPropagation && e.stopPropagation();
                        return false;
                    };
                }
            };
            scrollWheel.isDisabled = true;
        },
        scrollEnable: function scrollEnable() {
            document.documentElement.style.overflow = 'inherit';
            // document.body.style.overflow = 'unset';
            document.body.onkeydown = scrollWheel.oldonkeydown;
            scrollWheel.isDisabled = false;
        },
        disableScroll: function disableScroll() {
            if (window.addEventListener) {
                window.addEventListener('DOMMouseScroll', preventDefault, false);
            }
            window.onwheel = preventDefault; // modern standard
            window.onmousewheel = preventDefault; // older browsers, IE
            document.onmousewheel = preventDefault; // older browsers, IE
            window.ontouchmove = preventDefault; // mobile
            document.onkeydown = preventDefaultForScrollKeys;
            scrollWheel.isDisabled = true;
        },
        enableScroll: function enableScroll() {
            if (!scrollWheel.isDisabled) {
                return;
            }
            if (window.removeEventListener) {
                window.removeEventListener('DOMMouseScroll', preventDefault, false);
            }
            window.onwheel = scrollWheel.oldonwheel;
            window.onmousewheel = scrollWheel.oldonmousewheel1;
            document.onmousewheel = scrollWheel.oldonmousewheel2;
            window.ontouchmove = scrollWheel.oldontouchmove;
            document.onkeydown = scrollWheel.oldonkeydown;
            scrollWheel.isDisabled = false;
        }
    };
};
export var scrollWheel = scrollWheelFlag();

/**
 * css尺寸格式化
 * 比如：10px =》 10  和 10 =》 10px两种
 */

export var formatCSSTo = function formatCSSTo(e) {
    if (e === null) {
        return 0;
    }
    if (/^\d+px$/gi.test(e)) {
        return Number(e.replace(/px/gi, ''));
    }
    if (/^\d+$/gi.test(e)) {
        return Number(e);
    }
};
export var formatToCSS = function formatToCSS(e) {
    if (e === null) {
        return '0px';
    }
    if (/^\d+px$/gi.test(e)) {
        return e + '';
    }
    if (/^\d+$/gi.test(e)) {
        return e + 'px';
    }
};

/**
 * 计算字符串的字符数
 *
 * @param {string} str 字符串
 * @return {number} 字符数
 */
export var getChineseLength = function getChineseLength(str) {
    var isChinese = /[^\u0000-\u00FF]/; // eslint-disable-line
    var len = 0;
    if (!str) {
        return len;
    }
    var arr = str.split('');
    arr.forEach(function (item) {
        if (isChinese.test(item)) {
            len += 2;
        } else {
            len += 1;
        }
    });
    return len;
};
/**
 * matches兼容函数
 *
 * @param {element} dom元素，{selector}选择器
 * @return 布尔值
 */

export var matchesSelector = function matchesSelector(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    } else if (element.matchesSelector) {
        return element.matchesSelector(selector);
    } else if (element.webkitMatchesSelector) {
        return element.webkitMatchesSelector(selector);
    } else if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    } else if (element.mozMatchesSelector) {
        return element.mozMatchesSelector(selector);
    } else if (element.oMatchesSelector) {
        return element.oMatchesSelector(selector);
    }
};

export var classPrefix = 'spui2';

export var isIE = function isIE() {
    return 'ActiveXObject' in window;
};

/**
 * 监听任意盒子resize
 *
 */

export var EleResize = {
    handleResize: function handleResize(e) {
        var ele = e.target || e.srcElement;
        var trigger = ele.resizeTrigger;
        if (trigger) {
            var handlers = trigger.zResizeListeners;
            if (handlers) {
                var size = handlers.length;
                for (var i = 0; i < size; i++) {
                    var h = handlers[i];
                    var handler = h.handler;
                    var context = h.context;
                    handler.apply(context, [e]);
                }
            }
        }
    },
    removeHandler: function removeHandler(ele, handler, context) {
        var handlers = ele.zResizeListeners;
        if (handlers) {
            var size = handlers.length;
            for (var i = 0; i < size; i++) {
                var h = handlers[i];
                if (h.handler === handler && h.context === context) {
                    handlers.splice(i, 1);
                    return;
                }
            }
        }
    },
    createResizeTrigger: function createResizeTrigger(ele) {
        var obj = document.createElement('object');
        obj.setAttribute('style', 'display: block;\n            position: absolute;\n            top: 0; left: 0;\n            height: 100%;\n            width: 100%;\n            overflow: hidden;\n            opacity: 0;\n            pointer-events: none;\n            z-index: -1;');
        obj.onload = EleResize.handleObjectLoad;
        obj.type = 'text/html';
        ele.appendChild(obj);
        obj.data = 'about:blank';
        return obj;
    },
    handleObjectLoad: function handleObjectLoad() {
        this.contentDocument.defaultView.resizeTrigger = this.resizeElement;
        this.contentDocument.defaultView.addEventListener('resize', EleResize.handleResize);
    }
};

EleResize.on = function (ele, handler, context) {
    var handlers = ele.zResizeListeners;
    if (!handlers) {
        handlers = [];
        ele.zResizeListeners = handlers;

        if (getComputedStyle(ele, null).position === 'static') {
            ele.style.position = 'relative';
        }
        var obj = EleResize.createResizeTrigger(ele);
        ele.resizeTrigger = obj;
        obj.resizeElement = ele;
    }
    handlers.push({
        handler: handler,
        context: context
    });
};
EleResize.off = function (ele, handler, context) {
    var handlers = ele.zResizeListeners;
    if (handlers) {
        EleResize.removeHandler(ele, handler, context);
        if (handlers.length === 0) {
            var trigger = ele.resizeTrigger;
            if (trigger) {
                trigger.contentDocument.defaultView.removeEventListener('resize', EleResize.handleResize);
                ele.removeChild(trigger);
                delete ele.resizeTrigger;
            }
            delete ele.zResizeListeners;
        }
    }
};